/*
  Goloso Sano : trust line under the checkout button in the Essent cart drawer,
  and a copy of the announcement bar (sections/announcement-bar.liquid) as a
  banner under the drawer header, with the countdown mirrored. The banner only
  shows while the bar's countdown is running, so it follows the bar's own
  settings and disappears with it.

  The markup lives in snippets/gs-cart-trust.liquid as a <template>; this file
  only places one copy at the end of each checkout button wrapper. Essent
  rebuilds the drawer on open and on cart changes, so the placement is
  re-checked on DOM changes and is idempotent.

  Only stable data-essential-cart-element hooks are used, never generated
  Essent class names.
*/
(function () {
  "use strict";

  var tpl = document.getElementById("gs-cart-trust");
  if (!tpl || !tpl.content) return;

  var WRAPPER = '[data-essential-cart-element="checkout-button-wrapper"]';
  var TRUST_CLASS = "gs-trust";
  var HEADER = '[data-essential-cart-element="cart-drawer-header"]';
  var BANNER_CLASS = "gs-cart-announce";
  var SOURCE = ".announce[data-announce]";

  /* The announcement bar with a running countdown, or null (no timer on this
     page, not started yet, or ended). */
  function runningBar() {
    var bar = document.querySelector(SOURCE);
    if (!bar || bar.closest("." + BANNER_CLASS)) return null;
    var holder = bar.querySelector("[data-announce-timer]");
    if (!holder || holder.hidden) return null;
    return bar;
  }

  /* A copy of the bar as a banner right under the drawer header, so it has
     the bar's own look (Kenay 15-10). The copy is inert: no data-announce,
     so the bar script never touches it; the count is mirrored instead. */
  function placeBanner() {
    var headers = document.querySelectorAll(HEADER);
    var bar = runningBar();
    for (var i = 0; i < headers.length; i++) {
      var h = headers[i];
      var next = h.nextElementSibling;
      var banner = next && next.classList.contains(BANNER_CLASS) ? next : null;
      if (!bar) {
        if (banner) banner.remove();
        continue;
      }
      if (!banner) {
        banner = document.createElement("div");
        banner.className = BANNER_CLASS + " " + bar.className.replace(/\bannounce--link\b/, "");
        banner.setAttribute("aria-hidden", "true");
        banner.innerHTML = bar.innerHTML;
        var slides = banner.querySelectorAll("[hidden]");
        for (var s = 0; s < slides.length; s++) slides[s].hidden = false;
        h.parentNode.insertBefore(banner, h.nextSibling);
      }
      mirror(banner, bar);
    }
  }

  function mirror(banner, bar) {
    var src = bar.querySelector("[data-countdown]");
    var dst = banner.querySelector("[data-countdown]");
    if (src && dst && dst.textContent !== src.textContent) dst.textContent = src.textContent;
  }

  function tickBanners() {
    var bar = runningBar();
    var banners = document.querySelectorAll("." + BANNER_CLASS);
    for (var i = 0; i < banners.length; i++) {
      if (bar) mirror(banners[i], bar); else banners[i].remove();
    }
  }

  function place() {
    placeBanner();
    var wrappers = document.querySelectorAll(WRAPPER);
    for (var i = 0; i < wrappers.length; i++) {
      var w = wrappers[i];
      var existing = w.querySelector(":scope > ." + TRUST_CLASS);
      /* Keep it as the last child, below the button, also after a re-render
         that appended new nodes. */
      if (existing && existing === w.lastElementChild) continue;
      if (existing) {
        w.appendChild(existing);
      } else {
        w.appendChild(tpl.content.cloneNode(true));
      }
    }
  }

  var pending = false;
  function sync() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      place();
    });
  }

  function init() {
    sync();
    new MutationObserver(sync).observe(document.body, { childList: true, subtree: true });
    /* Back navigation restores the page from bfcache without re-running init. */
    window.addEventListener("pageshow", sync);
    setInterval(tickBanners, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
